<!-- Edit Mode -->
<ng-container *ngIf="editMode else viewMode">

    <div class="relative flex items-center justify-center w-32 h-32 rounded-full overflow-hidden ring-4 ring-bg-card">
        <!-- Upload / Remove avatar -->


        <!-- Image/Letter -->
        <div class="absolute inset-0 rounded-full bg-black bg-opacity-20 z-10">
            <!-- <div class="flex items-center justify-center w-full h-full rounded overflow-hidden uppercase text-6xl font-extrabold text-transparent  bg-clip-text bg-gradient-to-r opacity-90 hover:opacity-100 from-white to-white drop-shadow-md"
                *ngIf="!image">
                {{firstLetters}}
            </div> -->
        </div>
        <img class="object-cover w-full h-full"
            [src]="imageUrl?imageUrl:'assets/images/placeholders/placeholder-small.png'">

        <div class="absolute inset-0 flex items-center justify-center z-20">
            <div>

                <button (click)="openDialog()" mat-icon-button>
                    <mat-icon class="text-white" [svgIcon]="'fal:camera'">
                    </mat-icon>
                </button>

            </div>
            <div>
                <button (click)="deleteImage()" mat-icon-button>
                    <mat-icon class="text-red-500" [svgIcon]="'fal:trash-alt'">
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
</ng-container>

<!-- View Mode -->

<ng-template #viewMode>

    <div
        class="relative flex items-center justify-center w-32 h-32 rounded-full overflow-hidden z-10  ring-4 ring-bg-card">
        <img class="object-cover w-full h-full max-w-xs hover:scale-125 transition duration-300 ease-in-out z-0"
            [src]="imageUrl?imageUrl:'assets/images/placeholders/placeholder-small.png'">
        <div   *ngIf="!imageUrl" class="absolute inset-0 rounded-full bg-black bg-opacity-30 z-10 pointer-events-none">
            <div class="flex items-center justify-center w-full h-full rounded overflow-hidden uppercase text-6xl font-extrabold text-transparent  bg-clip-text bg-gradient-to-r opacity-90 hover:opacity-100 from-white to-white  drop-shadow-md"
              >
                {{firstLetters}}
            </div>
        </div>
    </div>

</ng-template>
